import { useCallback, useMemo } from 'react'

import {
  IContactGeneralFormRequiredFields,
  IContactGeneralFormValidation,
} from 'clickNgo/entities/contact'
import { useSafetyTranslation } from 'cng-common/features/translations'

import { contactGeneralStepValidationRules } from '../configs'
import { TRANSLATION_KEYS } from '../translations'

interface IUseGeneralStepValidationResult
  extends IContactGeneralFormRequiredFields,
    IContactGeneralFormValidation {}

export const useGeneralStepValidation = (): IUseGeneralStepValidationResult => {
  const t = useSafetyTranslation()

  const onFirstNameValidate = useCallback(
    (value: string) => {
      if (value.length > contactGeneralStepValidationRules.firstNameMaxLength) {
        return t(TRANSLATION_KEYS.validation.firstNameExceedMaxLength)
      }

      return ''
    },
    [t]
  )

  const onLastNameValidate = useCallback(
    (value: string) => {
      if (value.length > contactGeneralStepValidationRules.lastNameMaxLength) {
        return t(TRANSLATION_KEYS.validation.lastNameExceedMaxLength)
      }

      return ''
    },
    [t]
  )

  const onEmailValidate = useCallback(
    (value: string) => {
      if (value.length > contactGeneralStepValidationRules.emailMaxLength) {
        return t(TRANSLATION_KEYS.validation.emailExceedMaxLength)
      }

      return ''
    },
    [t]
  )

  return useMemo(
    () => ({
      onFirstNameValidate: onFirstNameValidate,
      onLastNameValidate: onLastNameValidate,
      onEmailValidate: onEmailValidate,
      isFirstNameRequired: true,
      isLastNameRequired: true,
      isEmailRequired: true,
    }),
    [onFirstNameValidate, onLastNameValidate, onEmailValidate]
  )
}
